import { Component, Fragment, Prop, getAssetPath, h } from '@stencil/core';
import state from '../../store';
import { CartItem, Icon } from '../../types';
import { groupCartItemsByStartFee, calculateStartFee, calculateGreenDiscount, calculateRot, calculateRut, getPartPrice, getProductPrice, getTotalPrice } from '../../utils/calc';

@Component({
  tag: 'hemfixarna-orderrows',
  shadow: false,
})
export class HemfixarnaOrderrows {
  @Prop() cart: boolean = true;

  goToProduct(id: number) {
    const products = state.customer.categories
      .map(c => (c.show_products ? c.products : c.sub_categories ? c.sub_categories.map(c => c.products) : []))
      .flat()
      .flat();
    const product = products.find(p => p && p.fields.ID === id);
    if (product) {
      state.selectedProduct = product.fields;
      state.step = 4;
    }
  }

  openModal(title: string, text: string) {
    state.modal = {
      title,
      text,
    };
  }

  getDiscountedInfo(item: CartItem) {
    if (item.rut && state.rut) {
      return ' (efter RUT-avdrag)';
    } else if (item.rot && state.rot) {
      return ' (efter ROT-avdrag)';
    } else if (item.green && state.green) {
      return ' (efter Grön teknik avdrag)';
    } else {
      return '';
    }
  }

  renderStartFees() {
    const startFees = new Set();
    const fees = [];
  
    state.cart.forEach(item => {
      const startFee = item.start_fee_obj;
      if (startFee && !startFees.has(startFee.ID)) {
        startFees.add(startFee.ID);
  
        const rotStartFee = item.rot ? calculateStartFee().rot : 0;
        const rutStartFee = item.rut ? calculateStartFee().rut : 0;
        const greenStartFee = item.green ? calculateStartFee().green : 0;
  
        fees.push({
          id: startFee.ID,
          name: startFee.title,
          price: startFee.price,
          text: startFee.pop_up,
          rot: rotStartFee,
          rut: rutStartFee,
          green: greenStartFee,
        });
      }
    });
  
    return fees.map(fee => (
      <div key={fee.id} class="hemfixarna_cart--startfee">
        <p onClick={() =>
              this.openModal(
                fee.name,
                fee.text
              )
            }>
          <strong>
            {fee.name}
          </strong>
          <img
            height={16}
            src={getAssetPath('./assets/info.svg')}
            alt="info monteringsavgift"
          />
        </p>
        <p>
          {!fee.rut && !fee.rot && !fee.green && <span>{fee.price}kr</span>}
          {fee.rut > 0 && <span>{fee.rut}kr (RUT)</span>}
          {fee.rot > 0 && <span>{fee.rot}kr (ROT)</span>}
          {fee.green > 0 && <span>{fee.green}kr (Grön teknik)</span>}
        </p>
      </div>
    ));
  }
  

  render() {
    return (
      <Fragment>
        <ul class="hemfixarna_cart--items">
          {Object.entries(groupCartItemsByStartFee(state.cart)).map(([startFeeID, items]) => (
            <li key={startFeeID} class="hemfixarna_cart--group">
              <ul>
                {items.map(item => (
                  <li class="hemfixarna_cart--item" key={item.id}>
                    <div>
                      <div>
                        {item.icon && (
                          <img
                            width={30}
                            src={(item.icon as Icon).url ?? (item.icon as string)}
                            alt={item.name}
                          />
                        )}
                        <p>
                          <strong>{item.amount}x </strong>
                          {item.name}
                        </p>
                      </div>
                      {this.cart && (
                        <button onClick={() => this.goToProduct(item.id)}>Ändra</button>
                      )}
                    </div>
                    <p>
                      <strong>{getProductPrice(item, item.price, item.amount)}kr</strong>
                      <span>{this.getDiscountedInfo(item)}</span>
                    </p>
                    {item.parts.length > 0 && (
                      <ul>
                        {item.parts.map(part => (
                          <li key={part.name}>
                            <p>
                              <strong>{part.amount}x </strong>
                              {part.name}
                            </p>
                            <p>
                              <strong>{getPartPrice(part, item, part.amount)}kr</strong>
                            </p>
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>
                ))}
              </ul>
            </li>
          ))}
        </ul>
        <div class="hemfixarna_cart--additional">
          {this.renderStartFees()}  
          {this.cart && state.cart.find((item: CartItem) => item.rot) && (
            <div class="hemfixarna_cart--rutrot">
              <div>
                <label class="switch">
                  <input checked={state.rot} onChange={() => (state.rot = !state.rot)} type="checkbox" />
                  <span class="slider"></span>
                </label>
                <p>ROT-avdrag</p>
              </div>
              <p>(-{state.rot ? calculateRot() : 0}kr)</p>
            </div>
          )}
          {this.cart && state.cart.find((item: CartItem) => item.rut) && (
            <div class="hemfixarna_cart--rutrot">
              <div>
                <label class="switch">
                  <input onChange={() => (state.rut = !state.rut)} checked={state.rut} type="checkbox" />
                  <span class="slider"></span>
                </label>
                <p>RUT-avdrag</p>
              </div>
              <p>(-{state.rut ? calculateRut() : 0}kr)</p>
            </div>
          )}
          {this.cart && state.cart.find((item: CartItem) => item.green) && (
            <div class="hemfixarna_cart--rutrot">
              <div>
                <label class="switch">
                  <input onChange={() => (state.green = !state.green)} checked={state.green} type="checkbox" />
                  <span class="slider"></span>
                </label>
                <p>Grön teknik avdrag</p>
              </div>
              <p>(-{state.green ? calculateGreenDiscount() : 0}kr)</p>
            </div>
          )}
        </div>

        <div class="hemfixarna_cart--price">
          <h2>Totalbelopp: </h2>
          <h2>{getTotalPrice()}kr</h2>
        </div>
      </Fragment>
    );
  }
}
